import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { LinkItem, SiteMenuInterface, siteMenu } from '../../site-menu';

@Component({
  selector: 'obs-site-search',
  templateUrl: './site-search.component.html',
  styleUrls: ['./site-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatAutocompleteModule, MatIconModule],
})
export class SiteSearchComponent implements OnInit {
  siteMenu: SiteMenuInterface[] = siteMenu;
  siteMenuFiltered$?: Observable<SiteMenuInterface[]>;

  searchForm: UntypedFormGroup = this._formBuilder.group({
    autoCompleteSearch: '',
  });

  constructor(
    private router: Router,
    private _formBuilder: UntypedFormBuilder,
  ) {}

  @ViewChild('searchBox') searchBox?: ElementRef<HTMLInputElement>;

  // Trigger the site search with `/` key
  // If we need more complexity, we can use
  // https://github.com/github/hotkey
  @HostListener('window:keydown', ['$event'])
  showSiteSearch(event: KeyboardEvent): void {
    const target = event.target as HTMLElement;
    const tag = target.tagName.toLowerCase();
    if (event.key === '/' && tag !== 'input' && tag !== 'textarea') {
      this.searchBox?.nativeElement.focus();
      event.preventDefault();
    }
  }

  ngOnInit(): void {
    const control = this.searchForm.get('autoCompleteSearch');
    if (!control) return;
    this.siteMenuFiltered$ = control.valueChanges.pipe(
      startWith(''),
      map((value) => this.filterGroup(value)),
    );
  }

  // Fires when you hit enter when autocomplete searching to navigate
  // to a new page. After you hit enter/return, the input is cleared
  // and the search input's focus is lost
  navigateToPage(event: MatAutocompleteSelectedEvent): void {
    const url = event.option.value;
    if (url) {
      this.searchForm.controls['autoCompleteSearch'].setValue('');
      this.searchBox?.nativeElement.blur();
      this.router.navigate([url]);
    }
  }

  private filterGroup(value: string): SiteMenuInterface[] {
    if (value) {
      return this.siteMenu
        .map((group) => ({
          groupName: group.groupName,
          links: this.filterItems(group.links, value),
        }))
        .filter((group) => group.links.length > 0);
    }
    return this.siteMenu;
  }

  private filterItems(opt: LinkItem[], value: string): LinkItem[] {
    const filterValue = value.toLowerCase();
    return opt.filter((item) => item.name.toLowerCase().replace(/\s/g, '').includes(filterValue));
  }
}
